export default __webpack_public_path__ + "images/example2.png?1c41540a4fd19a544c4173f2e1c6778d";